import defaultStyle from "./default";

export function appStyles(color, highlight) {
  const isColor = !color?.color?.primary;
  const isSolid = color?.elements?.style === "Solid"; //solid true
  const solidHighlight = highlight && isSolid;
  const outlinedHighlught = highlight && !isSolid;

  // Define the primary and secondary colors based on the highlighting and outline states.
  const primaryColor = !isSolid
    ? color?.color?.secondary || defaultStyle.color.secondary
    : color?.color?.primary || defaultStyle.color.primary;
  const secondaryColor = !isSolid
    ? color?.color?.primary || defaultStyle.color.primary
    : color?.color?.secondary || defaultStyle.color.secondary;

  const borderRadius =
    color?.elements?.shape === "Pill"
      ? "28px"
      : color?.elements?.shape === "Rounded"
      ? "16px"
      : "0px";

  const border = `${
    !isSolid
      ? `2px solid ${solidHighlight ? primaryColor : secondaryColor}`
      : "none"
  }`;

  const background = `${
     !outlinedHighlught
      ? isSolid
        ? solidHighlight
          ? secondaryColor
          : primaryColor
        : "none"
      : color?.color?.primary || defaultStyle.color.primary
  }`;

  const Color = `${
    highlight && !isSolid && isColor
      ? "white"
      : !outlinedHighlught
      ? solidHighlight
        ? primaryColor
        : secondaryColor
      : color?.color?.secondary
  }`;

  return {
    Color,
    background,
    border,
    borderRadius,
  };
}
